<template>
  <el-dialog
    v-dialogDrag
    title="可拖拽对话框"
    :visible.sync="dialogVisible"
    width="30%">
    <span>这是一个可拖拽的对话框</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  }
}
</script>